var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M-1991,9.465h21v2.07h-21Z","transform":"translate(1991 -9.465)"}));
}

Minus.defaultProps = {"width":"21","height":"2.07","viewBox":"0 0 21 2.07"};

module.exports = Minus;

Minus.default = Minus;
